import React from "react";
import PageHeaderContent from "../../components/pageHeaderContent";

const Reviews =()=>{

    return(
        <section id="reviews" className="reviews">

            <PageHeaderContent headerText="Reviews"/>

        </section>
    );

}

export default Reviews;